<template>
  <div id="app" align="center">
    <br>
    <img src="logo.png" width="40%"  >

    <font face='verdana'>
            <br>
       
            <div class="column is-three-fifths is-offset-one-half" >

                <div class="title is-5 has-text-left has-text-weight-light has-text-grey-dark">
                    <p class="is-family-serif">
                        <span>Detecta oportunamente fugas y excesos de consumo de agua emitiendo alertas personalizables <i class="fa fa-wifi" aria-hidden="true"></i> a tu App en tu celular o a tu email</span>
                    </p><br>
                    <p class="is-family-serif">Es una alarma inteligente de fugas y de consumos excesivos 24/7</p>
                    <br>
                    <p class="is-family-serif">Ahorra mucha agua y dinero en tu plaza comercial o condominio, oficinas u hogar.</p> 
                    <br>

                    <br>

                    <p class="is-family-serif">Con la App de Aqua Guardián puedes adicionalmente abrir o cerrar la llave en el momento u hora programada desde donde quiera que estés.</p>
                </div> 
                <br>             

            </div>

            <iframe
                width="448"
                height="252"
                :src="'https://www.youtube.com/embed/2DPLnhF2Co0'" 
                frameborder="2"
                allowfullscreen>
            </iframe>
            <br>
            Como funciona

            <br><br>


            <div class="columns">

                <div class="column is-primary" >
                    <stripe-buy-button
                      buy-button-id="prod_VZJOkUnUF512Ki"
                      publishable-key="pk_live_51ObyeVDz9w3F7wpMlSae9G9hu63TYm3DgrywEWQgM2LVVXhVrz7bQoGgESIjOvIQsmfle5xd76OhFzcz22FoEr4L00XYLNR21G"
                    >
                    </stripe-buy-button>
                </stripe-buy-button>
                </div>

                <div class="column is-primary">
                    <stripe-buy-button
                      buy-button-id="buy_btn_1Qf5NDDz9w3F7wpMWdUhUVVW"
                      publishable-key="pk_live_51ObyeVDz9w3F7wpMlSae9G9hu63TYm3DgrywEWQgM2LVVXhVrz7bQoGgESIjOvIQsmfle5xd76OhFzcz22FoEr4L00XYLNR21G"
                    >
                    </stripe-buy-button>
                </div>
            </div>


            <div>
                <p>
                    <a v-bind:href="'https://wa.me/521' + wapp
                            + '?text=Hola,%20me%20interesa%20el%20AquaGuardian' " target="_blank">
                            <i class="fab fa-whatsapp fa-2x"></i>
                    </a>
                </p><br>
                <p>
                    <a>aquaguardian@digita-ai.com</a>
                </p>
                <br><br>

                <footer class="footer">
                  <div class="content has-text-centered">
                    <p><small>Patente en trámite F011797/2024</small></p>
                  </div>
                </footer>

            </div>
            <br><br><br>

    </font>

  </div>
  
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      msg: 'Su gran ahorrador de agua',
      wapp: "4422853557",
      email:'',
      modelo:'Aqua Guardian $3,200 MXN',
      visible: false
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue